import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';
import { memo, useEffect } from 'react';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import type { FormModuleProps, ModuleTransformer } from '../types';
import styles from '../../LotteryForm.module.scss';

export const MODULE_NAME = 'no-communication';

export type NoCommunicationFormType = Static<typeof NoCommunicationFormSchema>;
export const NoCommunicationFormSchema = Type.Object(
  {},
  { additionalProperties: true, $id: 'NoCommunicationFormSchema' }
);

export const NoCommunicationTransformer: ModuleTransformer<NoCommunicationFormType> = {
  fromPayload: () => {
    return {};
  },
  toPayload: () => {
    return {};
  },
};

export type NoCommunicationFormProps = FormModuleProps<NoCommunicationFormType>;

export const NoCommunicationForm: React.FC<NoCommunicationFormProps> = memo(({ onChange }) => {
  const { t } = useTranslation();

  // This onChange is needed to make sure the module is included in the final state since it has no form
  useEffect(() => {
    onChange(MODULE_NAME, {});
  }, [onChange]);

  return (
    <div className={styles['text-container']}>
      <Text tagName="h2" headingSize="m">
        {t('lottery-form-no-communication-title')}
      </Text>
      <Text>{t('lottery-form-no-communication-description')}</Text>
    </div>
  );
});

export const module = {
  name: MODULE_NAME,
  transformer: NoCommunicationTransformer,
  form: NoCommunicationForm,
} as const;
